import React, { useEffect, useState } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'
import Badge from '../../../UniformComponents/Badge'
import Button from '../../../UniformComponents/Button'
import Typography from '../../../UniformComponents/Typography'

import './satisfactionOfObjectives.scss'
import LinkButton from '../../../UniformComponents/LinkButton'
import Input from '../../form/Input'

const SatisfactionOfObjectives = observer(({ chartData }) => {
    const renderRowValue = (value) => {
        const val = (Math.round(value * 10) / 10)
        let colourClass = 'green'
        if (val < 4) colourClass = 'yellow'
        if (val < 3) colourClass = 'red'

        return (
            <div className={`valueBadge ${colourClass}`}>
                <span className="val">{val}</span>
                /5
            </div>
        )
    }

    const renderRow = (row) => (
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div className="objName" style={{ flex: 1 }}>
                {row.name}
            </div>
            <div className="objDetails" style={{ display: 'flex', gap: '8px', flex: 1 }}>
                <div className="objPerc" style={{ flex: 1 }}>
                    {Math.round(row.percentage)}
                    %
                </div>
                <div className="objVal" style={{ flex: 1 }}>
                    {renderRowValue(row.value)}
                </div>
            </div>
        </div>
    )

    return (
        <div className="satisfactionWidget">
            <div className="title">
                Satisfaction of exhibiting objectives
            </div>
            <hr />
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div className="objNameTitle" style={{ flex: 1 }}>
                    OBJECTIVE
                </div>
                <div className="objDetailsTitle" style={{ display: 'flex', gap: '8px', flex: 1 }}>
                    <div className="objPercTitle" style={{ flex: 1 }}>
                        % OF OBJECTIVE HELD
                    </div>
                    <div className="objValTitle" style={{ flex: 1 }}>
                        Score (/5)
                    </div>
                </div>
            </div>
            {chartData.filter((row) => row.percentage)
                .sort((a, b) => b.percentage - a.percentage)
                .map((row) => renderRow(row))}
        </div>
    )
})

export default SatisfactionOfObjectives
